// extracted by mini-css-extract-plugin
export default {"modchartsLoading":"Loader_modchartsLoading__gpEhp"};